import React, { useMemo } from "react";
import {
  BonusDrawContainer,
  BonusDrawContent,
  BonusDrawHeader,
  BonusDrawImage,
  BonusDrawInfo,
  BonusDrawMedia,
  SubtitleText,
  TitleText,
} from "raffle-house-uikit";
import RaffleButton from "../common/RaffleButton";
import { getDaysLeft, isClosingSoon } from "../../helpers/getDaysLeft";
import { isFlashDrawActive } from "../../helpers/flashDraw";
import { Link } from "react-router-dom";

import "./style.scss";

export default function BonusDraw({
  onCTAClick,
  bonusDraw,
  videoData,
  content,
  flashDraw,
}) {
  const image = content.mainImage;
  const badgePrice = content.badgePrice;

  const daysLeft = bonusDraw.endAt ? getDaysLeft(bonusDraw.endAt) : 10;

  const badgeBaseUrl = process.env.REACT_APP_AWS_S3_URL + "icons/" || "";

  const badge = useMemo(() => {
    if (isClosingSoon(bonusDraw.endAt)) {
      const badgeName =
        daysLeft === 1
          ? "closing3.svg"
          : daysLeft === 2
            ? "closing2.svg"
            : "closing.svg";
      return (
        <div className="bonus-draw__badge bonus-draw__badge--top">
          <img
            decoding="async"
            loading="lazy"
            src={`${badgeBaseUrl}${badgeName}`}
            alt="Early Bird draw badge"
          />
        </div>
      );
    } else
      return (
        <div className="bonus-draw__badge">
          <span className="bonus-draw__badge-price">{badgePrice}</span>
          <img
            decoding="async"
            loading="lazy"
            src={content.badgeUrl}
            alt="Early Bird draw badge"
          />
        </div>
      );
  }, [daysLeft]);

  const poster =
    videoData && videoData.videoPreviewUrl && videoData.videoPreviewUrl.length
      ? videoData.videoPreviewUrl
      : null;
  const video =
    videoData && videoData.videoUrl && videoData.videoUrl.length
      ? videoData.videoUrl
      : null;
  // const poster =
  //   "https://raffle-house-production.s3.eu-west-1.amazonaws.com/bonus-draw/video/01.11.2025/eb-preview.jpg";
  // const video =
  //   "https://raffle-house-production.s3.eu-west-1.amazonaws.com/bonus-draw/video/01.11.2025/eb.mp4";

  return (
    <BonusDrawContainer>
      <BonusDrawHeader>
        <h2 className="bonus-draw__title">
          The {bonusDraw.profileTitle} Early Bird Draw
        </h2>
        <p className="bonus-draw__description">{bonusDraw.metaDescription}</p>
      </BonusDrawHeader>
      <BonusDrawContent>
        <div className="bonus-draw__info">
          <div className="bonus-draw__info-content">
            <h3 className="bonus-draw__info-title">{bonusDraw.metaTitle}</h3>
            <div className="bonus-draw__info-actions">
              <RaffleButton
                className="bonus-draw-info__button"
                onClick={onCTAClick}
                size="md"
                variant="primary"
              >
                Enter now
              </RaffleButton>
              <Link
                to="/early-bird"
                aria-label={`Learn more about the ${bonusDraw.profileTitle} Early Bird Draw`}
              >
                Learn more{" "}
                <svg
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.75 0.75L6.75 6.75L0.75 12.75"
                    stroke="#043B3B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
          {isFlashDrawActive(flashDraw) && (
            <div className="bonus-draw__info-flash-draw">
              <h3 className="bonus-draw__info-flash-draw-title">
                {flashDraw.title}
              </h3>
              <p className="bonus-draw__info-flash-draw-text">
                {flashDraw.description}
              </p>
            </div>
          )}
        </div>
        <BonusDrawMedia>
          {video ? (
            <video
              id="early-bird-draw-video"
              loop
              autoPlay={true}
              muted
              playsInline
              data-wf-ignore="true"
              data-object-fit="cover"
              poster={poster}
            >
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <BonusDrawImage
              srcSet={`
              ${image.image800Url} 800w,
              ${image.image1600Url} 1600w,
              ${image.image2048Url} 2048w,
              ${image.image3840Url} 3840w,
            `}
              sizes={`(max-width: 800px) 800px, (max-width: 1600px) 1600px, (max-width: 2048px) 2048px, 3840px`}
              src={image.image1600Url}
              alt={`The ${bonusDraw.profileTitle} Bonus Draw`}
            />
          )}
          {badge}
        </BonusDrawMedia>
      </BonusDrawContent>
      {isFlashDrawActive(flashDraw) && (
        <div className="bonus-draw__info-flash-draw bonus-draw__info-flash-draw--mobile">
          <h3 className="bonus-draw__info-flash-draw-title">
            {flashDraw.title}
          </h3>
          <p className="bonus-draw__info-flash-draw-text">
            {flashDraw.description}
          </p>
        </div>
      )}
    </BonusDrawContainer>
  );
}
